<template>
  <div class="form-patient-contacts">
    <div class="form-patient-contacts__phone-cards phone-cards">
      <input-typed-phone
        v-for="(
          {
            type,
            value,
            isMain,
            hasWhatsApp,
            note,
            key,
          }, index) in value.phoneList"
        v-bind:key="key"
        class="phone-cards__item"
        v-bind:class="{ 'phone-cards__item--active': isBacklightCardPhone(isMain) }"
        v-bind:title="index > 0 ? 'Дополнительный телефон' : 'Телефон'"
        v-bind:violations="phonesInputErrors[index]"
        v-bind:value="value"
        v-bind:type="type"
        v-bind:isNoteShow="true"
        v-bind:noteMaxLength="$options.maxNoteLength"
        v-bind:noteValue="note"
        v-on:input-note="onInputNote(index, $event)"
        v-on:invalid="onInvalid"
        v-on:input="onInputPhone(index, $event)"
      >
        <template v-if="isShowCheckboxMainPhone(type)" v-slot:before>
          <label class="phone-cards__row form-patient-contacts__control">
            <input
              title="Основной номер"
              class="form-patient-contacts__radio"
              type="radio"
              v-bind:id="`phone-number-main-${index}`"
              v-bind:checked="isMain"
              name="phone-number-main"
              v-on:input="onChangeMainPhone(index)">
            Номер для связи
          </label>
        </template>
        <the-tooltip v-if="restrictCalls" position="bottom">
          <template v-slot:trigger="{ listenerObject }">
            <button
              class="form-patient-contacts__phone"
              type="button"
              v-on="listenerObject" />
          </template>
          Пациент отказался от звонков
        </the-tooltip>
        <button
          class="form-patient-contacts__phone"
          v-else-if="canInitiateCall"
          type="button"
          title="Начать звонок"
          v-on:click="onInitiateCall(value)" />
        <the-tooltip v-if="restrictMailings && hasWhatsApp" position="bottom">
          <template v-slot:trigger="{ listenerObject }">
            <button
              class="form-patient-contacts__whats-app"
              type="button"
              v-on="listenerObject" />
          </template>
          Пациент отказался от рассылок
        </the-tooltip>
        <button
          v-else-if="hasWhatsApp"
          class="form-patient-contacts__whats-app"
          type="button"
          title="Открыть чат"
          v-on:click="onOpenWhatsAppChat(value)" />
        <the-tooltip v-if="restrictMailings && messengersAccess" position="bottom">
          <template v-slot:trigger="{ listenerObject }">
            <button
              class="form-patient-contacts__chat-push"
              type="button"
              v-on="listenerObject" />
          </template>
          Пациент отказался от рассылок
        </the-tooltip>
        <button
          v-else-if="messengersAccess"
          class="form-patient-contacts__chat-push"
          type="button"
          title="Открыть чат"
          v-on:click="onOpenMessengersChat(value)" />
        <button
          v-if="index === 0 && phoneNumberCount < $options.maxPhoneNumberCount"
          type="button"
          class="phone-cards__action phone-cards__action--add"
          title="Добавить телефон"
          v-on:click="onAddPhone" />
        <button
          v-if="phoneNumberCount > 1"
          type="button"
          class="phone-cards__action phone-cards__action--remove"
          title="Удалить телефон"
          v-on:click="onRemovePhone(index)" />
      </input-typed-phone>
      <input-typed-phone
        v-if="guardianPhone.number !== ''"
        v-bind:key="guardianPhone.number"
        class="phone-cards__item"
        v-bind:class="{ 'phone-cards__item--active': isBacklightCardPhone(guardianPhone.isMain) }"
        v-bind:title="'Телефон законного представителя'"
        v-bind:value="guardianPhone.number"
        v-bind:type="guardianPhone.type"
        v-bind:violations="guardianPhoneErrors"
        v-bind:isNoteShow="true"
        v-bind:noteMaxLength="$options.maxNoteLength"
        v-bind:noteValue="guardianPhone.note || ''"
        v-on:input-note="onInputGuardianNote"
        v-on:input="onInputGuardianPhone"
        v-on:invalid="onInvalid">
        <template v-if="isShowCheckboxMainPhone(guardianPhone.type)" v-slot:before>
          <label class="phone-cards__row form-patient-contacts__control">
            <input
              title="Основной номер"
              class="form-patient-contacts__radio"
              type="radio"
              v-bind:id="`phone-number-main-${value.phoneList.length}`"
              v-bind:checked="guardianPhone.isMain"
              name="phone-number-main"
              v-on:input="onChangeMainPhone(value.phoneList.length, true)">
            Номер для связи
          </label>
        </template>
        <the-tooltip v-if="restrictCalls" position="bottom">
          <template v-slot:trigger="{ listenerObject }">
            <button
              class="form-patient-contacts__phone"
              type="button"
              v-on="listenerObject" />
          </template>
          Пациент отказался от звонков
        </the-tooltip>
        <button
          class="form-patient-contacts__phone"
          v-else-if="canInitiateCall"
          type="button"
          title="Начать звонок"
          v-on:click="onInitiateCall(guardianPhone.number)" />
        <the-tooltip v-if="restrictMailings && guardianHasWhatsApp" position="bottom">
          <template v-slot:trigger="{ listenerObject }">
            <button
              class="form-patient-contacts__whats-app"
              type="button"
              v-on="listenerObject" />
          </template>
          Пациент отказался от рассылок
        </the-tooltip>
        <button
          v-else-if="guardianHasWhatsApp"
          class="form-patient-contacts__whats-app"
          type="button"
          title="Открыть чат"
          v-on:click="onOpenWhatsAppChat(guardianPhone.number)" />
        <the-tooltip v-if="restrictMailings && messengersAccess" position="bottom">
          <template v-slot:trigger="{ listenerObject }">
            <button
              class="form-patient-contacts__chat-push"
              type="button"
              v-on="listenerObject" />
          </template>
          Пациент отказался от рассылок
        </the-tooltip>
        <button
          v-else-if="messengersAccess"
          class="form-patient-contacts__chat-push"
          type="button"
          title="Открыть чат"
          v-on:click="onOpenMessengersChat(guardianPhone.number)" />
        <button
          v-if="phoneNumberCount > 1"
          type="button"
          class="phone-cards__action phone-cards__action--remove"
          title="Удалить телефон"
          v-on:click="onRemoveGuardianPhone" />
      </input-typed-phone>
    </div>
    <input-email
      class="form-patient-contacts__input"
      label=""
      placeholder="E-mail"
      v-bind:required="false"
      v-bind:value="value.email"
      v-bind:violations="emailInputErrors"
      v-on:input="onInputEmail"
    />
    <input-checkbox
      title="Согласен на рассылки"
      v-bind:value="value.isAllowedMailing"
      v-on:input="onInputIsAllowedMailing"
    />
    <input-checkbox
      title="Не звонить"
      v-bind:value="value.isNoCalls"
      v-on:input="onInputIsNoCalls"
    />
  </div>
</template>

<script>
import InputCheckbox from '@/components/InputCheckbox.vue';
import InputEmail from '@/components/InputEmail.vue';
import InputTypedPhone, { PHONE_TYPE_MOBILE } from '@/components/InputTypedPhone.vue';
import {
  GOAL_ADD_SECOND_PATIENT_PHONE,
  GOAL_CLICK_DO_NOT_CALL,
  GOAL_MAKE_MAIN_PATIENT_PHONE,
} from '@/plugins/metric';
import metricMixin from '@/mixins/metricMixin';
import { Phone } from '@/storage/gateways/PatientGateway';
import TheTooltip from '@/components/TheTooltip.vue';

/**
 * @description Контакты пациента.
 * @param {string}  email
 * @param {boolean} isAllowedMailing
 * @param {boolean} isNoCalls
 * @param {any[]}   phoneList
 * @constructor
 */
export function PatientContacts(
  email = '',
  isAllowedMailing = true,
  isNoCalls = false,
  phoneList = [],
) {
  this.email = email;
  this.isAllowedMailing = isAllowedMailing;
  this.isNoCalls = isNoCalls;
  this.phoneList = phoneList.length === 0 ? [{
    type: PHONE_TYPE_MOBILE, value: '', isMain: true, note: '', key: Date.now(),
  }] : phoneList;

  this.setEmail = (value) => new this.constructor(
    value,
    isAllowedMailing,
    isNoCalls,
    phoneList,
  );
  this.setIsAllowedMailing = (value) => new this.constructor(
    email,
    value,
    isNoCalls,
    phoneList,
  );
  this.setIsNoCalls = (value) => new this.constructor(
    email,
    isAllowedMailing,
    value,
    phoneList,
  );
  this.setPhoneList = (value) => new this.constructor(
    email,
    isAllowedMailing,
    isNoCalls,
    value,
  );

  this.toString = () => JSON.stringify({
    email,
    isAllowedMailing,
    isNoCalls,
    phoneList: this.phoneList.map(({
      type, value, isMain, note,
    }) => ({
      type, value, isMain, note,
    })),
  });
}

/**
 * @description Максимальная длина примечания
 * @type {int}
 */
const MAX_NOTE_LENGTH = 180;

/**
 * @description Название события ввода.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Названеие события изменения статуса значения "не звонить".
 * @type {string}
 */
const NAME_EVENT_CHANGE_STATUS_NO_CALL = 'change-status-no-call';

/**
 * @description Название события ввода номера ЗП.
 * @type {string}
 */
const NAME_EVENT_INPUT_GUARDIAN_PHONE = 'input-guardian-phone';

/**
 * @description Название события инициации звонка.
 * @type {string}
 */
const NAME_EVENT_INITIATE_CALL = 'initiate-call';

/**
 * @description Максимальное количество телефонов у пациента.
 * @type {number}
 */
const MAX_PHONE_NUMBER_COUNT = 2;

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.violationCauses ? vm.violationCauses[cause] : []
);

/**
 * @description Пустой список нарушения ограничений телефонных номеров.
 * @type {Array}
 */
const EMPTY_PHONE_VIOLATIONS = [];
/**
 * @description Компонент формы контактов пациента.
 * @type {Vue}
 */
export default {
  maxNoteLength: MAX_NOTE_LENGTH,
  maxPhoneNumberCount: MAX_PHONE_NUMBER_COUNT,
  phoneTypeMobile: PHONE_TYPE_MOBILE,
  components: {
    TheTooltip,
    InputCheckbox,
    InputEmail,
    InputTypedPhone,
  },
  computed: {
    /**
     * @description Запрет рассылок.
     * @returns {boolean}
     */
    restrictMailings() {
      return !this.value.isAllowedMailing;
    },
    /**
     * @description Запрет звонков.
     * @returns {boolean}
     */
    restrictCalls() {
      return this.value.isNoCalls && this.canInitiateCall;
    },
    emailInputErrors: resolveInputErrors('email'),
    phonesInputErrors() {
      const numbers = [];
      for (let i = 0; i < this.phoneNumberCount; i += 1) {
        const cause = `phone-list.${i}`;
        const causes = cause in this.violationCauses
          ? this.violationCauses[cause]
          : EMPTY_PHONE_VIOLATIONS;
        numbers.push(causes);
      }
      return numbers;
    },
    /**
     * @description Количество телефонных номеров.
     * @type {number}
     */
    phoneNumberCount() {
      let count = this.value.phoneList.length;
      count += this.guardianPhone.number !== '' ? 1 : 0;
      return count;
    },
  },
  methods: {
    onInputNote(index, note) {
      const phoneList = this
        .value
        .phoneList
        .map((phone, i) => (i === index ? { ...phone, note } : phone));
      this.$emit(NAME_EVENT_INPUT, this.value.setPhoneList(phoneList));
    },
    /**
     * @description Показывать ли чекбокс выбора основного номера.
     * @type {bool}
     */
    isShowCheckboxMainPhone(typePhone) {
      return this.hasChangeMainPhone
        && this.$options.phoneTypeMobile === typePhone;
    },
    /**
     * @description Подсвечивать ли карточку с основным номером.
     * @type {bool}
     */
    isBacklightCardPhone(isMainPhone) {
      return isMainPhone
        && this.hasChangeMainPhone;
    },
    /**
     * @description Обработать добавление телефона.
     * @returns {void}
     */
    onAddPhone() {
      if (this.phoneNumberCount < MAX_PHONE_NUMBER_COUNT) {
        let phoneList = this.value.phoneList.slice();
        phoneList.push({
          value: '',
          type: PHONE_TYPE_MOBILE,
          isMain: false,
          key: Date.now(),
        });
        phoneList = this.updateMainPhone(phoneList);
        this.$emit(NAME_EVENT_INPUT, this.value.setPhoneList(phoneList));
        this.reachAddSecondPatientPhoneGoal();
      }
    },
    /**
     * @description Обработать событие - добавление второго телефона пациенту.
     * @returns {void}
     */
    reachAddSecondPatientPhoneGoal() {
      this.reachGoalIfNotReach(GOAL_ADD_SECOND_PATIENT_PHONE);
    },
    /**
     * @description Обработать ввод электронного адреса.
     * @param {string} value
     * @returns {void}
     */
    onInputEmail(value) {
      this.$emit(NAME_EVENT_INPUT, this.value.setEmail(value));
    },
    /**
     * @description Обработать ввод согласия рассылки.
     * @param {boolean} value
     * @returns {void}
     */
    onInputIsAllowedMailing(value) {
      this.$emit(NAME_EVENT_INPUT, this.value.setIsAllowedMailing(value));
    },
    /**
     * @description Обработать ввод не звонить.
     * @param {boolean} value
     * @returns {void}
     */
    onInputIsNoCalls(value) {
      this.reachDoNotCallReach();
      this.$emit(NAME_EVENT_INPUT, this.value.setIsNoCalls(value));
      this.$emit(NAME_EVENT_CHANGE_STATUS_NO_CALL, value);
    },
    /**
     * @description Достигнута цель - не звонить.
     * @returns {void}
     */
    reachDoNotCallReach() {
      this.reachGoalIfNotReach(GOAL_CLICK_DO_NOT_CALL);
    },
    /**
     * @description Обработать ввод телефона.
     * @param {number} index
     * @param {any}    newValue
     * @returns {void}
     */
    onInputPhone(index, newValue) {
      const updatePhones = (candidate, candidateIndex) => (
        index === candidateIndex ? { ...candidate, ...newValue } : candidate
      );
      const phoneList = this.value.phoneList.map(updatePhones);
      const newPatientContacts = this.value.setPhoneList(phoneList);
      this.$emit(NAME_EVENT_INPUT, newPatientContacts);
    },
    /**
     * @description Обработать изменение основного телефона.
     * @param {number} index
     * @param {boolean} guardianPhoneIsMain
     * @returns {void}
     */
    onChangeMainPhone(index, guardianPhoneIsMain = false) {
      const updatePhones = (candidate, candidateIndex) => {
        const item = candidate;
        item.isMain = candidateIndex === index;
        return item;
      };
      const phoneList = this.value.phoneList.map(updatePhones);
      this.$emit(NAME_EVENT_INPUT, this.value.setPhoneList(phoneList));
      const { guardianPhone } = this;
      guardianPhone.isMain = guardianPhoneIsMain
        ? !guardianPhone.isMain
        : false;
      this.$emit(NAME_EVENT_INPUT_GUARDIAN_PHONE, guardianPhone);
      this.reachMakeMainPatientPhone();
    },
    /**
     * @description Достичь цели - телефон пациента сделан основным
     * @returns {void}
     */
    reachMakeMainPatientPhone() {
      this.reachGoalIfNotReach(GOAL_MAKE_MAIN_PATIENT_PHONE);
    },
    /**
     * @description Обработать некорректность поля.
     * @returns {void}
     */
    onInvalid() {
      this.$emit('invalid');
    },
    /**
     * @description Обработать инициацию звонка.
     * @param {string} phoneNumber
     * @returns {void}
     */
    onInitiateCall(phoneNumber) {
      this.$emit(NAME_EVENT_INITIATE_CALL, phoneNumber);
    },
    /**
     * @description Обработать отправку события открытия WhatsApp чата.
     * @param {string} phoneNumber
     * @returns {void}
     */
    onOpenWhatsAppChat(phoneNumber) {
      this.$emit('open-whats-app-chat', phoneNumber);
    },
    /**
     * @description Обработать отправку события открытия чата Мессенджеров.
     * @param {string} phoneNumber
     * @returns {void}
     */
    onOpenMessengersChat(phoneNumber) {
      this.$emit('open-messengers-chat', phoneNumber);
    },
    /**
     * @description Обработать удаление телефона.
     * @returns {void}
     */
    onRemovePhone(index) {
      if (this.phoneNumberCount > 1) {
        let phoneList = [...this.value.phoneList];
        phoneList.splice(index, 1);
        phoneList = this.updateMainPhone(phoneList);
        this.$emit(NAME_EVENT_INPUT, this.value.setPhoneList(phoneList));
      }
    },
    /**
     * @description Обработать ввод номера телефона ЗП.
     * @param {Object} newValue
     */
    onInputGuardianPhone(newValue) {
      const { value, type } = newValue;
      const updatedGuardianPhone = new Phone(
        value,
        type,
        this.guardianPhone.isMain,
        this.guardianPhone.note || '',
      );
      this.$emit(NAME_EVENT_INPUT_GUARDIAN_PHONE, updatedGuardianPhone);
    },
    /**
     * @description Обработать ввод примечания для телефона ЗП.
     * @param {string} note
     * @returns {void}
     */
    onInputGuardianNote(note) {
      const updatedGuardianPhone = new Phone(
        this.guardianPhone.number,
        this.guardianPhone.type,
        this.guardianPhone.isMain,
        note,
      );
      this.$emit(NAME_EVENT_INPUT_GUARDIAN_PHONE, updatedGuardianPhone);
    },
    /**
     * @description Удалить телефон ЗП.
     * @returns {void}
     */
    onRemoveGuardianPhone() {
      this.$emit(NAME_EVENT_INPUT_GUARDIAN_PHONE, new Phone());
      this.$nextTick(() => {
        const phoneList = this.updateMainPhone();
        this.$emit(NAME_EVENT_INPUT, this.value.setPhoneList(phoneList));
      });
    },
    /**
     * @description Обновить основной номер.
     * @returns {array}
     */
    updateMainPhone(phones = null) {
      const phoneList = phones ?? this.value.phoneList.slice();
      if (
        !phoneList.find((item) => item.isMain)
        && !this.guardianPhone.isMain
        && phoneList.find((phone) => phone.type === this.$options.phoneTypeMobile)
      ) {
        phoneList.find((phone) => phone.type === this.$options.phoneTypeMobile).isMain = true;
      }
      return phoneList;
    },
  },
  name: 'FormPatientContacts',
  mixins: [metricMixin],
  props: {
    /**
     * @description Может инициировать звонки.
     */
    canInitiateCall: { default: () => false, type: Boolean },
    /**
     * @description Значение.
     * @type {PatientContacts}
     */
    value: { required: true, type: PatientContacts },
    /**
     * @description Номер ЗП.
     * @type {Phone}
     */
    guardianPhone: { default: () => new Phone(), type: Phone },
    /**
     * @description Номер ЗП.
     * @type {Boolean}
     */
    guardianHasWhatsApp: { default: () => false, type: Boolean },
    guardianPhoneErrors: { default: () => [], type: Array },
    /**
     * @description Нарушения ограничений.
     * @type {Object}
     */
    violationCauses: { required: true, type: Object },
    /**
     * @description Редактировать изменение основного телефона.
     * @type {Boolean}
     */
    hasChangeMainPhone: { default: () => true, type: Boolean },
    /**
     * @description Доступ к мессенджерам.
     * @type {Boolean}
     */
    messengersAccess: { default: () => false, type: Boolean },
  },
};
</script>
<style scoped lang="scss">
.form-patient-contacts {
  flex-direction: column;
  display: flex;
  gap: 27px;
  position: relative;
  &__phone {
    width: 20px;
    height: 20px;;
    margin-right: auto;
    background-image: url('@/assets/img/phone-blue.svg');
    background-size: contain;
    background-position: center;
    &:hover {
      filter: brightness(95%) contrast(85%);
    }
  }
  &__whats-app {
    width: 22px;
    height: 22px;
    margin-right: auto;
    background-image: url('@/assets/img/social/whatsapp-brand-green.svg');
    background-size: contain;
    background-position: center;
    &:hover {
      filter: brightness(95%) contrast(85%);
    }
  }
  &__chat-push {
    width: 25px;
    height: 25px;
    margin-right: auto;
    background-image: url('@/assets/img/chat.svg');
    background-size: contain;
    background-position: center;
    &:hover {
      filter: brightness(95%) contrast(85%);
    }
  }
  &__control {
    display: flex;
    align-items: center;
    column-gap: 10px;
    cursor: pointer;
  }
  &__radio {
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    background: var(--primary-background-color);
    border: 1px solid  var(--unfocus-color);
    border-radius: 15px;
    -webkit-appearance: none;
    appearance: none;
    cursor: pointer;
    &:checked {
      border-color: var(--action-color);
    }
    &:checked:after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: var(--action-color);
      transform: translate(-50%, -50%);
    }
    &:hover {
      border-color: var(--action-color);
    }
  }
  &__input {
    max-width: 242px;
    width: 100%;
  }
  &-add,
  &-remove {
    font-weight: 400;
    font-size: 16px;
    color: var(--action-color);
    padding: 7px 0;
    cursor: pointer;
  }
  &-remove {
    color: var(--warning-color);
  }
}

.phone-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 24px;
  &__item {
    padding: 20px;
    border-radius: 10px;
    border: 2px solid var(--border-color);
    &--active {
      border-color: #0489E0;
      background: #ffffff;
    }
  }
  ::v-deep(.input-typed-phone) {
    .phone-cards__row {
      width: 100%;
      margin-bottom: 30px;
    }
  }
  &__action {
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background: no-repeat 50%;
    background-color: var(--fill-color);
    background-size: 19px 19px;
    outline: 1px solid transparent;
    transition: outline-color 0.3s;
    &--add {
      background-image: url('@/assets/img/plus-black.svg');
      background-size: 26px 26px;
    }
    &--remove {
      background-image: url('@/assets/img/exit-black.svg');
    }
    &:hover {
      outline-color:  var(--action-color);
    }
  }
}

@media screen and (max-width: 480px) {
  .form-patient-contacts {
    &__input {
      max-width: 100%;
    }
  }
  .phone-cards {
    &__item {
      width: 100%;
    }
  }
}
</style>
